export * from './delete-objekt-nutzung.component';
export * from './delete-objekt-nutzung.component.module';